// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__HusNZ","col":"Table_col__23OM9","fulfillmentStatus":"Table_fulfillmentStatus__3IklJ","emailCol":"Table_emailCol__1wwB2"};